import { convertDate, titleCase } from "../../../Utils/titleCaseFunction";
import { useEffect, useState } from "react";
import axios from "axios";
import config from "../../../Helpers/config.json";
import { errorMessages } from "../../../Helpers/ErrorMessages";
import { useAddCustomer } from "../../Customer/CustomHooks/useAddCustomer";
import { v4 as uuidv4 } from "uuid";

export const useReusableNewWholeSales = (
  actions,
  invoice_number = "",
  is_cash = false,
  saletype = "",
) => {
  // console.log(saletype)
  const defaultCustomer =
  is_cash && saletype === "retail"
    ? { customer_name: "Walk-in Customer", customer_id: "1" }
    : "";

  const initialState = [
    {
      product_name: "",
      batch_id: "",
      batch_info: [],
      available_quantity: "",
      expiry: "",
      unit: "",
      product_quantity: "",
      product_rate: "",
      discount: "",
      total_price: "",
      discount_type: 1,
      related_product: "",
      total_discount: 0,
      tax: "",
      dosage: "",
      product_id: "",
      showProduct: false,
      isError: false,
      isPriceLower:false,
      batch_details_id: "", // add this

      isDiscountable:false,
      uuid_id: uuidv4(),
      discount_rate:0,
    },
  ];
  const [paytype, setPayType] = useState("");
  const [customer, setCustomer] = useState(defaultCustomer);
  const [showCustomer, setShowCustomer] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [rows, setRows] = useState(initialState);
  const [drugs, setDrugs] = useState([]);
  const [state, setState] = useState({
    invoice_date: convertDate(),
    inva_details: "",
  });
  const [totals, setTotals] = useState({
    grand_total_price: 0,
    n_total: 0,
    change: 0,
    due_amount: 0,
    paid_amount: "",
    previous_amount: 0,
    total_discount_amount: 0,
  });
  const [customerDetails, setCustomerDetails] = useState({
    credit_limit: 0,
    isCreditError: false,
  });
  const { customerProps } = useAddCustomer(actions, "new-customer");
  const [prevProducts, setPrevProducts] = useState([]);
  const [prevAmount, setPrevAmount] = useState(0);
  const [amountPaid, setAmountPaid] = useState(0);
  const [paymentType, setPaymentType] = useState("");
  const [isBlocking, setIsBlocking] = useState(false);





  useEffect(() => {
    console.log("Sale type changed:", saletype);
  
    if (saletype === "retail" && is_cash) {
      // For cash retail sales, default customer
      setCustomer({ customer_name: "Walk-in Customer", customer_id: "1" });
    } else {
      // For wholesale or other types, clear customer if needed
      setCustomer(""); // or keep previous customer if you want
    }
  
    // Reset other invoice states
    resetInvoiceState();
  }, [saletype]);
  
  const resetInvoiceState = () => {
    setRows(initialState);
    setTotals({
      grand_total_price: 0,
      n_total: 0,
      change: 0,
      due_amount: 0,
      paid_amount: "",
      previous_amount: 0,
      total_discount_amount: 0,
    });
    setCustomerDetails({ credit_limit: 0, isCreditError: false });
    setDrugs([]);
    setState({ invoice_date: convertDate(), inva_details: "" });
    setAmountPaid(0);
    setPrevProducts([]);
    setPrevAmount(0);
  };
  

  // useEffect(() => {
  //   // whenever saletype changes, reset your invoice state
  //   // console.log(" Changing Am done here ..   ")
  //   // const defaultCustomer =
  //   // is_cash && saletype === "retail"
  //   //   ? { customer_name: "Walk-in Customer", customer_id: "1" }
  //   //   : "";
  //   // alert(defaultCustomer);
  //   // setCustomer(defaultCustomer)
  //   resetState();
  // }, [saletype]);
  


  // const resetState = () => {
  //   // setCustomer(defaultCustomer);
  //   setRows(initialState);
  //   setTotals({
  //     grand_total_price: 0,
  //     n_total: 0,
  //     change: 0,
  //     due_amount: 0,
  //     paid_amount: "",
  //     previous_amount: 0,
  //     total_discount_amount: 0,
  //   });
  //   setCustomerDetails({ credit_limit: 0, isCreditError: false });
  //   setDrugs([]);
  //   setState({ invoice_date: convertDate(), inva_details: "" });
  //   setAmountPaid(0);
  //   setPrevProducts([]);
  //   setPrevAmount(0);
  // };
  

  const groupByProductId = (arr = [], product_details = []) => {
    let empty = [];
    let obj = {};
    // console.log(arr);
    for (let j = 0; j < product_details.length; j++) {
      for (let i = 0; i < arr.length; i++) {
        // console.log("arr", arr[i].batch);
        if (product_details[j].product_id === arr[i].product_id) {
          obj = { ...product_details[j], ...arr[i] };
        }
      }
      empty.push(obj);
    }

    // console.log("empty", empty);
    return empty;
  };

  // using the batch_details_id to compare now instead of batch_id
  const getBatchDetails = (b_id, batch_data = []) => {
    // console.log(`batch_details`, b_id, batch_data)

    const arr = batch_data
      .filter((item) => item.batch_details_id === b_id)
      .map((item) => ({
        ...item,
        expiry: item.expiry_date,
        available_quantity: item.stock,
      }));

    // console.log(arr);

    return arr[0];
  };

  const handleGetCustomer = (event) => {
    console.log("triggered ")
    if (!event["innerText"]) {
      // console.log("gwe ... ")
      setCustomer({ customer_name: "", customer_id: "" });
      setShowCustomer(false);
      return;
    }
    // console.log("not yet there ...")
    const { innerText, value } = event;
    // console.log("innerText ",innerText ," value ",value)
    const id = value ? value.split("-")[0] : "";
    const limit = value ? value.split("-")[1] : 0;
    setCustomer({ customer_name: innerText, customer_id: id });
    setCustomerDetails({ ...customerDetails, credit_limit: parseInt(limit) });
    return axios.get(`${config.epharmUrl}/Cinvoice/outstanding_balance`, {
      params: { customer_id: id },
    });
  };

  useEffect(() => {
    if (!invoice_number) {
      return;
    }
    
    // console.log("invoice_number am here ",invoice_number)
    // console.log("sale type ",saletype)
    const storage = JSON.parse(sessionStorage.getItem(invoice_number));
    // console.log("storage am here ..  ",storage)
    const item = storage ? storage : {};
    // console.log("item am here ..  ",item)

    const customer_details = item["customer"] ? item["customer"] : {};
    // console.log("customer_details ",customer_details)
    const product_details = item["products"] ? item["products"] : {};
    const obj = {
      innerText: customer_details.customer_name,
      value: `${customer_details.customer_id}-${customer_details.credit_limit}`,
    };
    // console.log("customer_details.customer_name  ",customer_details.customer_name)

    // console.log("customer_details.customer_id  ",customer_details.customer_id)
    const amount_paid = customer_details?.amount_paid
      ? customer_details?.amount_paid
      : 0;
    const pay_type = customer_details?.payment_type
      ? customer_details?.payment_type
      : 0;
    setCustomer({ customer_name: customer_details.customer_name, customer_id: customer_details.customer_id });
    // console.log("customer ",customer)
    if (!obj.innerText) {
      return;
    }
    // const obj = {
    //   innerText: customer_details.customer_name,
    //   value: `${customer_details.customer_id}-${customer_details.credit_limit}`,
    // };
    
    // set state
    setCustomer({
      customer_name: customer_details.customer_name,
      customer_id: customer_details.customer_id,
    });
    console.log("date ",customer_details.date)
    setShowCustomer(true); // make sure the autocomplete shows
// inside your useEffect
if (customer_details.date) {
  // Example: "Sun, 07 Sep 2025 09:09:54 GMT"
  const dateParts = customer_details.date.split(" "); // ["Sun,", "07", "Sep", "2025", "09:09:54", "GMT"]
  
  const day = dateParts[1]; // "07"
  const monthStr = dateParts[2]; // "Sep"
  const year = dateParts[3]; // "2025"

  // Map month abbreviation to number
  const monthMap = {
    Jan: "01", Feb: "02", Mar: "03", Apr: "04", May: "05", Jun: "06",
    Jul: "07", Aug: "08", Sep: "09", Oct: "10", Nov: "11", Dec: "12",
  };
  const month = monthMap[monthStr];

  const formattedDate = `${year}-${month}-${day}`; // YYYY-MM-DD
  setState({ invoice_date: formattedDate, inva_details: "" });
} else {
  setState({ invoice_date: convertDate(), inva_details: "" }); // fallback
}



    
    // populate the options so it displays correctly
    setCustomers([
      {
        label: customer_details.customer_name,
        value: `${customer_details.customer_id}-${customer_details.credit_limit}`,
      },
    ]);
    // handleGetCustomer(obj);

    handleGetCustomer(obj)
      .then((response) => {
        const data = response.data;
        const dt = !data ? {} : data;
        const amount = dt.data ? dt.data : 0;
        Promise.all(
          product_details.map((item) => {
            return axios
              .post(
                `${config.epharmUrl}/Cinvoice/retrieve_product_data_inv_edit`,
                null,
                { params: { product_id: item.product_id } },
              )
              .then((response) => {
                return response;
              });
          }),
        ).then(function (result) {
          const dt = result ? result : [];
          const arr = dt.map(({ data }) => data);
          const empty = groupByProductId(arr, product_details);
          const emp = empty.map((item) => {
          console.log("item", item);
            return {
              ...item,
              ...getBatchDetails(item.batch_details_id, item.batch),
            };
          });

          // console.log("emp", emp);

          const resultArr = groupByProductId(arr, emp);

          let productIds = resultArr.map((item) => {
            const total = +item.quantity *( saletype === "wholesale"?+item.wholesale_price : +item.price);
            const disc = item.discount ? item.discount : 0;
            const discount = total * (+disc / 100);
            const discount_amount = total * (+disc / 100);
            const dis_total = +item.quantity * +item.rate;
            const final_total = total - discount;

            const originalRate = saletype === "wholesale" ? +item.wholesale_price : +item.price;
            const quantity = +item.quantity;
            const unitRate = +item.rate; // rate from DB or previously entered?
            const discountValue = item.discount_amount>0?(originalRate - (unitRate-item.discount)) :0; // discount already applied
            const totalPrice = quantity * (unitRate-item.discount); // total using the rate after discount

            // get batch details : batch_id and batch_details_id
            // const get_current_batch_details = item.batch.find(
            //   (ele) => ele.batch_details_id === item.batch_details_id,
            // );
            // const current_batch_details = {
            //   batch_id: get_current_batch_details.batch_id ?? "nop",
            //   batch_details_id:
            //     get_current_batch_details.batch_details_id ?? "",
            // };

            // const bArr = item?.batch?.map(({batch_id}) => batch_id)
            return {
              ...item,
              product_id: item.product_id,
              // batch_id: current_batch_details?.batch_id?? "",
              product_quantity: item.quantity,
              product_rate:item.rate,
              discount: item.discount_amount,
              discount_rate:item.discount,
              total_price: (item.rate-item.discount_amount)*item.quantity,
              batch_info: item.batch,
              unit: item.unit,
              original_rate:(saletype === "wholesale"?item.wholesale_price : item.price),
              total_stock: item.total_product,

            };
          });
          const finalProducts = productIds.map((product) => ({
            ...product,
            uuid_id: product.uuid_id || uuidv4(), // ensure every product has a unique ID
          }));
          
          setPrevProducts(finalProducts);
          setPrevAmount(amount);
          setAmountPaid(amount_paid);
          setPaymentType(pay_type);
        });
      })
      .catch((error) => {
        errorMessages(error, null, actions);
      });
  }, [invoice_number]);

  useEffect(() => {
    if (!invoice_number) {
      return;
    }
    setRows(prevProducts);
    // setPayType(paymentType);
    calculateTotalAmounts(prevProducts, amountPaid, prevAmount);
  }, [prevAmount, prevProducts, amountPaid, paymentType]);

  const handleChangePaymentMethod = (event) => {
    const { value } = event.target;
    setPayType(value);
    setIsBlocking(true);
  };

  const handleChangeFormFields = (event) => {
    const { name, value } = event.target;
    setState({ ...state, [name]: value });
    setIsBlocking(true);
  };

  const handleChange = (event, index) => {
    const { value, name } = event.target;
    const arr = rows.map((item, idx) => {
      if (idx === index) {
        return { ...item, [name]: value };
      }
      return value;
    });
    setRows(arr);
    setIsBlocking(true);
  };
const calculateTotalAmounts = (arr = [], p_amount = 0, prev_amount = 0) => {
  let sum = 0;
  let totalDiscount = 0;

  arr.forEach((row) => {
    const qty = Number(row.product_quantity) || 0;
    const rate = Number(row.product_rate) || 0;
    const discountPerUnit = Number(row.discount) || 0;

    const lineTotal = (rate - discountPerUnit) * qty;
    sum += lineTotal;

    totalDiscount += discountPerUnit * qty;
  });

  const net_total = sum;
  const due_amount = Math.max(0, net_total - Number(p_amount));
  const change = Math.max(0, Number(p_amount) - net_total);

  setTotals({
    ...totals,
    grand_total_price: sum,
    n_total: net_total,
    due_amount,
    change,
    total_discount_amount: totalDiscount,
    paid_amount: p_amount,
    previous_amount: prev_amount,
  });
};
  // const calculateTotalAmounts = (arr, p_amount, prev_amount) => {
  //   // Calculate total price using product_rate and subtract discount
  //   const sum = arr.reduce((a, row) => {
  //     const discountAmount = row.discount || 0; // discount per unit
  //     const total_price = (row.product_rate - discountAmount) * (row.product_quantity || 0);
  //     return a + total_price;
  //   }, 0);
  
  //   // Calculate total discount amount (discount * quantity)
  //   const discount = arr.reduce((a, row) => {
  //     const row_discount = (row.discount || 0) * (row.product_quantity || 0);
  //     return a + row_discount;
  //   }, 0);
  
  //   const net_total = sum; // total after discounts
  //   const amount_due = net_total - (p_amount || 0);
  //   const final_due = amount_due > 0 ? amount_due : 0;
  
  //   const change = (p_amount || 0) - net_total;
  //   const final_change = change > 0 ? change : 0;
  
  //   setTotals({
  //     ...totals,
  //     grand_total_price: sum,
  //     n_total: net_total,
  //     due_amount: final_due,
  //     change: final_change,
  //     total_discount_amount: discount,
  //     paid_amount: p_amount,
  //     previous_amount: prev_amount,
  //   });
  // };
  
  
  // const calculateTotalAmounts = (arr, p_amount, prev_amount) => {
  //   console.log(arr)
  //   const sum = arr.reduce((a, row) => {
  //     return Number(a + row.total_price);
  //   }, 0);
  //   const discount = arr.reduce((a, row) => {
  //     let total_apparent = +(row.product_rate * row.product_quantity);
  //     console.log(total_apparent)
  //     let dis = !row.discount_rate ? 0 : +(row.discount_rate * total_apparent);
  //     let disc = dis / 100;
  //     return a + disc;
  //   }, 0);
  //   const net_total = sum; //+(sum + prev_amount);
  //   const amount = +(net_total - p_amount);
  //   const final_amount = amount > 0 ? amount : 0;
  //   const change = +(p_amount - net_total);
  //   const final_change = change > 0 ? change : 0;
  //   setTotals({
  //     ...totals,
  //     grand_total_price: sum,
  //     n_total: +net_total,
  //     due_amount: final_amount,
  //     change: final_change,
  //     total_discount_amount: +discount,
  //     paid_amount: p_amount,
  //     previous_amount: prev_amount,
  //   });
  // };

  // const handleChangeQuantity = (event, index) => {

  //   const { value } = event.target;

  //   const { paid_amount, previous_amount } = totals;

  //   const updatedRows = rows.map((row, idx) => {
  //     if (index !== idx) {
  //       return row;
  //     }
  //     const discount_value = +row.discount;

  //     const total = +value * row?.product_rate;

  //     const final_total = total ;
      

  //     return {
  //       ...row,
  //       product_quantity: value,
  //       total_price: final_total,
  //       // discount_rate: +discount_rate,
  //       isError: +value > row?.available_quantity,
        
  //     };
  //   });

  //   setRows(updatedRows);

  //   calculateTotalAmounts(updatedRows, paid_amount, previous_amount);

  //   setIsBlocking(true);
  // };


const handleChangeQuantity = (event, index) => {
  const { value } = event.target;
  const qty = value === "" ? "" : Math.max(0, Number(value)); // Allow empty or positive numbers

  const { paid_amount, previous_amount } = totals;

  const updatedRows = rows.map((row, idx) => {
    if (idx !== index) {
      return { ...row }; // ← Important: create new reference
    }

    const rate = row.product_rate || 0;
    const total_price = qty * rate;

    return {
      ...row,
      product_quantity: qty,
      total_price: total_price || 0,
      isError: qty > (row.available_quantity || 0),
    };
  });

  setRows(updatedRows);
  calculateTotalAmounts(updatedRows, paid_amount, previous_amount);
  setIsBlocking(true);
};




  const handleChangeDiscount = (event, index) => {
    const { paid_amount, previous_amount } = totals;
    const { value } = event.target;
    
  
    const arr = rows.map((item, idx) => {
      
      const original_rate = item.original_rate || item.product_rate;
      const discount_value = +value;
  
      // Ensure discount doesn't exceed the original rate
      const unit_rate = Math.max(original_rate - Math.abs(discount_value), 0);

  
      // Calculate discount percentage
      const discount_rate = (discount_value / original_rate) * 100;
  
      // Calculate the final total
      const final_total = +item.product_quantity * unit_rate;

      // Calculate discounted unit rate without overwriting original_rate
    const discounted_rate = original_rate - discount_value;

  
      // Validate input
      const isDiscountable = discount_value > item.product_rate;
  
      return index === idx
        ? {
            ...item,
            discount: discount_value,
            discount_rate:Math.round(discount_rate),
            total_price: final_total,
            discounted_rate,
            // product_rate: unit_rate,
            original_rate,
            isDiscountable,
          }
        : item;
    });
  
    setRows(arr);
    calculateTotalAmounts(arr, paid_amount, previous_amount);
    setIsBlocking(true);
  };
  


  const handleChangeBalance = (event) => {
    const { previous_amount } = totals;
    const { value } = event.target;
    calculateTotalAmounts(rows, value, previous_amount);
    setIsBlocking(true);
  };

  const handleRetrieveCustomerInfo = (event) => {
    const customer_value = event.target ? event.target.value : event;
    setCustomer({ ...customer, customer_name: customer_value });
    if (customer_value !== "") {
      axios
        .get(`${config.epharmUrl}/Cinvoice/customer_autocomplete`, {
          params: { customer_id: titleCase(customer_value) },
        })
        .then((res) => {
          const data = res.data;
          const dt = !data ? [] : data;
          const arr = dt.map((item) => ({
            value: `${item.customer_id}-${item.credit_limit}`,
            label: item.customer_name,
          }));
          setCustomers(arr);
        })
        .catch((error) => {
          errorMessages(error, null, actions);
        });
      setShowCustomer(true);
    } else {
      setShowCustomer(false);
    }
    // setIsBlocking(true)
  };

  const handleClickCustomer = (event) => {
    const { paid_amount } = totals;
    if (!event["innerText"]) {
      return;
    }
    handleGetCustomer(event)
      .then((response) => {
        const data = response.data;
        const dt = !data ? {} : data;
        const amount = dt.data ? dt.data : 0;
        setTotals({ ...totals, previous_amount: amount });
        calculateTotalAmounts(rows, paid_amount, amount);
      })
      .catch((error) => {
        errorMessages(error, null, actions);
      });
    setShowCustomer(false);
    // setIsBlocking(true)
  };

  const [isOpen, setIsOpen] = useState(false);

  const [expiredDrugReason, setExpiredDrugReason] = useState("");

  const [clickedDrugIndex, setClickedDrugIndex] = useState(0);

  const [showExpiredDrugReasonInput, setShowExpiredDrugReasonInput] =
    useState(false);

  const [showExpiredDrugDialog, setShowExpiredDrugDialog] = useState(false);

  // const handleRetrieveDrugs = (eventTxt, index) => {
  //   let tmp = eventTxt.trim();

  //   if (tmp.includes("(")) {
  //     tmp = tmp.substring(0, tmp.indexOf("("));
  //   }

  //   const arr = rows.map((item, idx) => {
  //     if (idx === index) {
  //       if (tmp !== "") {
  //         axios
  //           .get(`${config.epharmUrl}/Cinvoice/autocompleteproductsearch_with_stock`, {
  //             params: { product_name: titleCase(tmp) },
  //           })
  //           .then((res) => {
  //             const data = res.data;

  //             const dt = !data ? [] : data;

  //             const arr = dt.map((item) => ({
  //               value: item.value,
  //               label: `${item.label}-${item.generic_name}`,
  //               generic_name: item.generic_name,
  //             }));

  //             setDrugs(arr);
  //           })
  //           .catch((error) => {
  //             errorMessages(error, null, actions);
  //           });

  //         return { ...item, product_name: tmp, showProduct: true };
  //       } else {
  //         return {
  //           ...item,
  //           product_name: tmp,
  //           showProduct: false,
  //           batch_id: "",
  //           batch_info: [],
  //           available_quantity: 0,
  //           product_rate: 0,
  //           product_quantity: "",
  //           expiry: "",
  //           unit: "",
  //           total_price: 0,
  //           discount: "",
  //         };
  //       }
  //     }

  //     return item;
  //   });

  //   // console.log(arr);

  //   setRows(arr);

  //   setIsBlocking(true);
  // };
  const handleRetrieveDrugs = (eventTxt, index) => {
    let tmp = eventTxt; // keep spaces for display
  
    const searchTxt = tmp.includes("(") ? tmp.substring(0, tmp.indexOf("(")) : tmp;
    const trimmedSearch = searchTxt.trim(); // only trim for API
  
    if (trimmedSearch !== "") {
      axios
        .get(`${config.epharmUrl}/Cinvoice/autocompleteproductsearch_with_stock`, {
          params: { product_name: titleCase(trimmedSearch) },
        })
        .then((res) => {
          const data = res.data;
          const dt = !data ? [] : data;
  
          const arr = dt.map((item) => ({
            value: item.value,
            label: `${item.label}-${item.generic_name}`,
            generic_name: item.generic_name,
          }));
  
          setDrugs(arr);
        })
        .catch((error) => {
          errorMessages(error, null, actions);
        });
    }
  
    const arr = rows.map((item, idx) => {
      if (idx === index) {
        if (tmp !== "") {
          return { ...item, product_name: tmp, showProduct: true };
        } else {
          return {
            ...item,
            product_name: tmp,
            showProduct: false,
            batch_id: "",
            batch_info: [],
            available_quantity: 0,
            product_rate: 0,
            product_quantity: "",
            expiry: "",
            unit: "",
            total_price: 0,
            discount: "",
          };
        }
      }
      return item;
    });
  
    setRows(arr);
    setIsBlocking(true);
  };
  
  const handleClickDrugTwo = (event, index) => {
    const { value, innerText } = event;

    setClickedDrugIndex(index);

    const updatedRows = rows.map((row, idx) =>
      idx === index
        ? {
            ...row,
            showProduct: false,
            product_id: value,
            product_name: innerText,
          }
        : row,
    );

    setRows(updatedRows);

    axios
      .post(`${config.epharmUrl}/Cinvoice/retrieve_product_data_inv`, null, {
        params: { product_id: value },
      })
      .then((response) => {
        const data = response?.data;

        let batches = data?.batch ?? [];

        batches =
          batches.length > 0
            ? batches.map(({ batch_id, batch_details_id }) => ({
                batch_id,
                batch_details_id,
              }))
            : [];

        const batchID = batches[0]?.batch_details_id ?? "";

        const batch = getBatchDetails(batchID, data?.batch ?? []);
        // const batch_details_id = batchObj?.batch_details_id ?? ""; // NEW
        // const batchID = batches[0]?.batch_id ?? "";
        const batchObj = getBatchDetails(batchID, data?.batch ?? []); // current function
        const batch_details_id = batchObj?.batch_details_id ?? ""; // NEW

        // console.log(batch)

        if (batch?.days_until_expiry <= batch.expiry_days) {
          setShowExpiredDrugDialog(true);

        }


        return setRows(
          updatedRows.map((row, idx) =>
            index === idx
              ? {
                  ...row,
                  ...getBatchDetails(batch, data?.batch ?? []),
                  batch_info: data?.batch ?? [],
                  unit: data.unit ?? "",
                  total_stock: data.total_product ?? 0,
                  product_rate: (saletype === "wholesale"?data?.wholesale_price : data?.price)?? "",
                  available_quantity: batch?.stock ?? 0,
                  expiry: batch?.expiry,
                  batch_id: batchObj?.batch_id ?? "anoe",
                  batch_details_id: batchObj?.batch_details_id ?? "", // add this

                  dosage: "",
                  original_rate:(saletype === "wholesale"?data?.wholesale_price : data?.price)?? "",
                }
              : row,
          ),
        );
      })
      .catch((error) => {
        errorMessages(error, null, actions);
        // console.log(error)
      });
  };
  // console.log(rows)

  const handleClickDrug = (event, index) => {
    handleClickDrugTwo(event, index);
    
  };
  const handleChangeBatch = (batch_details_id, index) => {
    const batch_value = batch_details_id.target ? batch_details_id.target.value : batch_details_id;
  
    const updatedRows = rows.map((item, idx) => {
      if (idx !== index) return item;
  
      const batchObj = item.batch_info.find(
        (b) => b.batch_details_id === batch_value
      ) || {};
  
      const exp_date = batchObj.expiry_date ?? "";
      const daysLeft = exp_date
        ? Math.floor((new Date(exp_date) - new Date()) / (1000 * 60 * 60 * 24))
        : null;
  
      if (batchObj.days_until_expiry <= batchObj.expiry_days) {
        setShowExpiredDrugDialog(true);
      }
  
      // EXPIRED batch
      if (daysLeft !== null && daysLeft < 0) {
        return {
          ...item,
          available_quantity: "",
          expiry_date: "",
          expired: true,
          batch_id: "",
          batch_details_id: "",
          dosage: "",
          // reset flags
          isPriceLower: false,
          isError: false,
        };
      }
  
      // 🟢 NEW FIX — RECALCULATE stock + flags after batch change
      const newAvailableQty = batchObj.stock ?? "";
      const newQuantity = item.product_quantity || 0;
  
      return {
        ...item,
        batch_id: batchObj.batch_id ?? "",
        batch_details_id: batchObj.batch_details_id ?? "",
        available_quantity: newAvailableQty,
        expiry_date: batchObj.expiry_date ?? "",
        expired: false,
  
        // 🟢 RESET VALIDATION FLAGS
        isPriceLower: newQuantity > newAvailableQty, // recalc stock issue
        isError: false, // stop old errors from carrying over
      };
    });
  
    setRows(updatedRows);
    setIsBlocking(true);
  };
  
  // const handleChangeBatch = (batch_details_id, index) => {
  //   const batch_value = batch_details_id.target ? batch_details_id.target.value : batch_details_id;
  //   console.log("batch_details_id", batch_details_id);

  //   // const batch_value = batch_details_id

  //   console.log("batch_value", batch_value);
  
  //   const updatedRows = rows.map((item, idx) => {
  //     if (idx !== index) return item;
  
  //     // Find the selected batch
  //     const batchObj = item.batch_info.find(
  //       (b) => b.batch_details_id === batch_value
  //     ) || {};
  
  //     // Expiry calculation
  //     const exp_date = batchObj.expiry_date ?? "";
  //     const daysLeft = exp_date
  //       ? Math.floor((new Date(exp_date) - new Date()) / (1000 * 60 * 60 * 24))
  //       : null;
  
  //     // Show expired dialog if near expiry
  //     if (batchObj.days_until_expiry <= batchObj.expiry_days) {
  //       setShowExpiredDrugDialog(true);
  //     }
  
  //     // Expired batch handling
  //     if (daysLeft !== null && daysLeft < 0) {
  //       return {
  //         ...item,
  //         available_quantity: "",
  //         expiry_date: "",
  //         expired: true,
  //         batch_id: "",
  //         batch_details_id: "",
  //         dosage: "",
  //       };
  //     }
  
  //     // Update row with selected batch
  //     return {
  //       ...item,
  //       batch_id: batchObj.batch_id ?? "",
  //       batch_details_id: batchObj.batch_details_id ?? "",
  //       available_quantity: batchObj.stock ?? "",
  //       expiry_date: batchObj.expiry_date ?? "",
  //       expired: false,
  //     };
  //   });
  
  //   console.log("updatedRows", updatedRows);
  //   setRows(updatedRows);
  //   setIsBlocking(true);
  // };
  
  

  // // batch_value now holds the batch_details_id instead of batch_id
  // const handleChangeBatch = (event, index) => {
  //   const batch_value = event.target ? event.target.value : event;
  //   console.log("batch_value", batch_value);

  //   const arr = rows.map((item, idx) => {
  //     const batchObj = getBatchDetails(event.target.value, item.batch_info);
  //     console.log("batchObj", batchObj);

  //     const obj = batchObj ? batchObj : {};

  //     const exp_date = obj.expiry ? obj.expiry : "";

  //     const daysLeft = Math.floor(
  //       (Date.parse(exp_date) - Date.now()) / (24 * 60 * 60 * 1000),
  //     );
  //     if (obj?.days_until_expiry <= obj.expiry_days) {
  //       setShowExpiredDrugDialog(true);
  //     }
  //     if (idx === index) {
  //       console.log("daysLeft ", daysLeft);
  //       if (daysLeft < 0) {
  //         console.log("daysLeft  < 0 ", daysLeft);

  //         return {
  //           ...item,
  //           available_quantity: "",
  //           expiry: "",
  //           expired: true,
  //           batch_id: "",
  //           batch_details_id: "", // reset
  //           dosage: "",
  //         };
  //       } else {
  //         console.log("obj else ", obj);
  //         return {
  //           ...item,
  //           ...getBatchDetails(batch_value, item.batch_info),
  //           batch_id: obj?.batch_id || "noe",
  //           // batch_details_id: getBatchDetails(batch_value, item.batch_info)?.batch_details_id ?? "", // add batch_details_id
  //           batch_details_id: obj?.batch_details_id ?? "", // add this
  //           expired: false,
  //         };
  //       }
  //     }

  //     return item;
  //   });

  //   // const isExpired = arr.every((item) => item.expired);
  //   //
  //   // if (isExpired) {
  //   //   actions.snackbarActions.infoSnackbar(
  //   //     "Batch Expired, Please Choose another"
  //   //   );
  //   // }
  //   console.log("arr", arr);
  //   setRows(arr);

  //   setIsBlocking(true);
  // };

  const handleAddRow = () => {
    const item = {
      product_name: "",
      batch_id: "",
      batch_info: [],
      available_quantity: "",
      expiry: "",
      unit: "",
      product_quantity: "",
      product_rate: "",
      discount: 0,
      discount_rate:0,
      total_price: "",
      discount_type: 1,
      total_discount: 0,
      product_id: "",
      tax: 0,
      dosage: "",
      showProduct: false,
      batch_details_id: "", // add this
      uuid_id: uuidv4(),
    };
    setRows((prevRows) => [...prevRows, item]);

    // setRows([...rows, item]);
    setIsBlocking(true);
  };

  // const handleChangeRate = (event, index) => {
  //   const { value } = event.target;
  //   const { paid_amount, previous_amount } = totals;
  
  //   const updatedRows = rows.map((row, idx) => {
  //     if (index !== idx) return row;
  
  //     const newRate = parseFloat(value) || 0;
  
  //     const isPriceLower = newRate < row.original_rate; // cannot reduce
  //     const total = newRate * (row.product_quantity || 0);
  
  //     return {
  //       ...row,
  //       product_rate: newRate,
  //       total_price: total,
  //       isPriceLower,
  //     };
  //   });
  
  //   setRows(updatedRows);
  //   calculateTotalAmounts(updatedRows, paid_amount, previous_amount);
  //   setIsBlocking(true);
  // };
  // const handleChangeRate = (event, index) => {
  //   const { value } = event.target;
  //   const { paid_amount, previous_amount } = totals;
  
  //   const updatedRows = rows.map((row, idx) => {
  //     if (index !== idx) return row;
  
  //     const newRate = parseFloat(value) || 0;
  //     // console.log(" row.original_rate ",row.original_rate )

  //     const isPriceLower = newRate < row.original_rate;
  //     // console.log(" isPriceLower ",isPriceLower )
  
  //     const appliedRate = isPriceLower ? row.original_rate : newRate; // use original_rate if lower
  //     const total = appliedRate * (row.product_quantity || 0);
  
  //     return {
  //       ...row,
  //       product_rate: newRate, // keep entered rate in field
  //       total_price: total,
  //       isPriceLower,
  //     };
  //   });
  
  //   setRows(updatedRows);
  //   calculateTotalAmounts(updatedRows, paid_amount, previous_amount);
  //   setIsBlocking(true);
  // };
  
const handleChangeRate = (event, index) => {
  const { value } = event.target;
  const newRate = value === "" ? "" : Math.max(0, Number(value));

  const { paid_amount, previous_amount } = totals;

  const updatedRows = rows.map((row, idx) => {
    if (idx !== index) {
      return { ...row }; // ← Important: new reference
    }

    const originalRate = row.original_rate || 0;
    const rateToUse = newRate === "" ? 0 : newRate;

    const isPriceLower = typeof newRate === "number" && newRate < originalRate;

    // Use original rate if user tries to put lower price
    const finalRate = isPriceLower ? originalRate : rateToUse;
    const total_price = finalRate * (row.product_quantity || 0);

    return {
      ...row,
      product_rate: newRate,        // Keep what user typed (even if invalid)
      total_price: total_price || 0,
      isPriceLower,
    };
  });

  setRows(updatedRows);
  calculateTotalAmounts(updatedRows, paid_amount, previous_amount);
  setIsBlocking(true);
};


  const handleAddFourRows = () => {
    const newItems = Array.from({ length: 4 }, () => ({
      product_name: "",
      batch_id: "",
      batch_info: [],
      available_quantity: "",
      expiry: "",
      unit: "",
      product_quantity: "",
      product_rate: "",
      discount: 0,
      discount_rate: 0,
      total_price: "",
      discount_type: 1,
      total_discount: 0,
      product_id: "",
      tax: 0,
      dosage: "",
      showProduct: false,
      uuid_id: uuidv4(),
    }));
  
    setRows((prevRows) => [...prevRows, ...newItems]);
    setIsBlocking(true);
  };
  

  
  const handleRemoveSpecificRow = (idx) => {
    const { paid_amount, previous_amount } = totals;
    const updatedRows = [...rows];
    const arr = rows.filter((item) => item.uuid_id !== rows[idx].uuid_id);

    // updatedRows.splice(idx, 1);
    // const arr = rows.filter((_, index) => index !== idx)
    setRows(arr);
    // console.log("index", idx);
    calculateTotalAmounts(arr, paid_amount, previous_amount);
    setIsBlocking(true);
  };

  const handleCloseExpiredDialog = () => {
    setIsOpen(false);
  };

  const openExpiredDrugReasonInput = () => {
    setShowExpiredDrugReasonInput(true);
  };

  const closeExpiredDrugReasonInput = () => {
    setShowExpiredDrugReasonInput(false);
  };

  const openExpiredDrugDialog = () => {
    setShowExpiredDrugDialog(true);
  };

  const closeExpiredDrugDialog = () => {
    setShowExpiredDrugDialog(false);
    setShowExpiredDrugReasonInput(false);
    setExpiredDrugReason("");
  };

  const handleChangeExpiredDrugReason = (event) => {
    setExpiredDrugReason(event.target.value);


    setRows(
      rows.map((row, idx) =>
        idx === clickedDrugIndex
          ? { ...row, expiredDrugReason: event.target.value }
          : row,
      ),
    );
  };



  const stateVariables = {
    initialState,
    paytype,
    customer,
    showCustomer,
    rows,
    state,
    // setState,
    customerProps,
    customerDetails,
    totals,
    customers,
    drugs,
    handleChangeFormFields,
    handleChangePaymentMethod,
    handleChange,
    handleChangeBatch,
    handleAddRow,
    handleRemoveSpecificRow,
    handleChangeQuantity,
    handleChangeDiscount,
    handleChangeBalance,
    handleRetrieveCustomerInfo,
    handleClickCustomer,
    handleRetrieveDrugs,
    handleClickDrug,
    isBlocking,
    isOpen,
    handleCloseExpiredDialog,
    expiredDrugReason,
    showExpiredDrugReasonInput,
    showExpiredDrugDialog,
    openExpiredDrugReasonInput,
    closeExpiredDrugReasonInput,
    openExpiredDrugDialog,
    closeExpiredDrugDialog,
    handleChangeExpiredDrugReason,
    handleAddFourRows,
    handleChangeRate,
  };

  const stateFunctions = {
    setRows,
    setCustomer,
    setTotals,
    setCustomerDetails,
    setIsBlocking,
    setState,
  };

  return { stateVariables, stateFunctions };
};
// 289 branch
